import React from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router';
import { ChevronRightIcon } from '@radix-ui/react-icons';
import { Avatar } from '@producer/ui-kit';

import { Contact } from '../../../app/entities/contact';
import { useResponsive } from '../../../hooks/useResponsive';

import styles from './contact-with-preview.module.scss';
type ContactWithPreviewProps = {
  contact: Contact;
};

const isSelected = (contactId: string) => {
  const path = window.location.pathname.split('/');

  return path[path.length - 1] === contactId;
};

export const ContactWithPreview: React.FC<ContactWithPreviewProps> = observer(({ contact }) => {
  const navigate = useNavigate();
  const { isMobile } = useResponsive();

  return (
    <div
      className={styles['container']}
      onClick={() => navigate(`../${contact._id}`)}
      data-selected={isSelected(contact._id)}
    >
      <div className={styles['left']}>
        {/* @todo: Remove the AvatarWrapper and instead redesign the Avatar component itself */}
        <div className={styles['avatar-wrapper']}>
          <Avatar src={contact.avatar} initials={contact.initials} size="fill" theme="dark" />
        </div>

        <div className={styles['content']}>
          <h3 className={styles['title']}>{contact.fullName}</h3>
          <div className={styles['profession']}>{contact.role}</div>
        </div>
      </div>

      {isMobile && <ChevronRightIcon color="var(--color-grayscale-manatee)" />}
    </div>
  );
});
